var English = "Anglais";
var French = "Français";
var German = "Allemand";
var Italian = "Italien";
var Japanese = "Japonais";
var Korean = "Coréen";
var Portuguese = "Portugais";
var Russian = "Russe";
var Spanish = "Espagnol";
var Bahasa = "Bahasa";
var Thai = "Thaï";
var Vietnamese = "Vietnamien";
var Turkish = "Turc";
var Arabic = "Arabe";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Chinois simplifié",
	"Chinese-Traditional": "Chinois traditionnel",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
